import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientDot } from '_components'
import { patientActions } from '_actions';
import styles from './OutstandingNotesRow.module.css'
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


class TherapistDashboardOutstandingNotesRow extends React.Component {

    rowClicked(e) {
        switch (this.props.note.TYPE) {
            case 1:
            case 3:
                this.props.openEditNote(this.props.note.PTNO, this.props.note.NOTEID, this.props.note.EPNO);
                break;
            case 2:
                this.props.openPatientStartNote(this.props.note.PTNO, this.props.note.EPNO, this.props.note.ADTAPTID, this.props.note.DATE, undefined)
                break;
            default:
                break;
        }
    }

    getNoteType() {
        switch (this.props.note.TYPE) {
            case 1:
                return 'Note In-Progress'
            case 2:
                return 'Appt. Checked In'
            case 3:
                return 'Note Rejected'
            default:
                return ''
        }
    }

    render() {
        return (
            <div className={styles.note_wrapper} onClick={e => this.rowClicked(e)}>
                <span className={this.props.note.MTNO === 3 || this.props.note.MTNO === 5 ? styles.pnCol : styles.col}>
                    <span className={styles.fixedWidth}>{this.props.note.TYPE === 1 &&
                        <FontAwesomeIcon icon={faSpinner} color={this.props.color ? this.props.color : "#f7941d"} />
                    }
                        {this.props.note.TYPE === 2 &&
                            <FontAwesomeIcon icon={faCheck} transform="shrink-5" color="green" />
                        }
                        {this.props.note.TYPE === 3 &&
                            <FontAwesomeIcon icon={faExclamation} transform="shrink-5" color="red" />
                        }
                    </span>
                    <PatientDot id={this.props.note.DOT} />
                    <label
                        className={styles.patient_name + (this.props.note.ISFEDERAL ? ' ' + styles.italic : '') + (this.props.note.ISEVAL ? ' ' + styles.bold : '')}
                        title={this.props.note.PTFNAME + ' ' + this.props.note.PTLNAME + ' - ' + this.getNoteType()}
                    >

                        {this.props.note.PTFNAME + ' ' + this.props.note.PTLNAME + ' '}


                    </label>
                </span>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openEditNote: bindActionCreators(patientActions.openEditNote, dispatch),
        openPatientStartNote: bindActionCreators(patientActions.openStartNote, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let note = state.entities.dashboard.outstandingNotes[ownprops.id];

    return {
        note,
    };
}

const connectedTherapistDashboardOutstandingNotesRow = connect(mapStateToProps, mapDispatchToProps)(TherapistDashboardOutstandingNotesRow);
export { connectedTherapistDashboardOutstandingNotesRow as TherapistDashboardOutstandingNotesRow };

